export default __webpack_public_path__ + "static/media/feed1.0d877f47.jpg";